import React, { useRef, useState } from "react";
import API from "api";
import PopUps from "./PopUps";
import ResourceCheck from "../../components/SectionalTest/ResourceCheck";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import TestHeader from "./TestHeader";
import Questions from "./Questions";
import BottomBtns from "./BottomBtns";
import MockInfo from "./MockInfo";
import { NavLink } from "react-router-dom";
import Unfinished from "./Unfinished";

const TestBody = ({ mockData, setMockData, routeState, soundArr }) => {
  const timerRef = useRef();
  const [questionsFunctions, setQuestionsFunctions] = useState(null);
  const [showMockInfo, setShowMockInfo] = useState(true);
  const currentQuestionRef = useRef(0);
  // Fallback functions in case Questions component functions are not ready
  const fallbackFinalObjectCreation = () => {
    const actualCurrentQuestion = currentQuestionRef.current;
    let qdata = mockData.questionData[actualCurrentQuestion];
    return {
      type: qdata.subcategory_id,
      id: qdata.id,
      response: true,
      answer: qdata.question,
      script: qdata.audio_script,
      q_ans: qdata.answer
    };
  };

  const fallbackFinalSubmit = (obj1) => {
  const actualCurrentQuestion = currentQuestionRef.current; 
  let { questionData, pending } = mockData;
  let curr = questionData[actualCurrentQuestion];
  
  console.log("=== TIMEOUT SUBMIT ===");
  console.log("actualCurrentQuestion from ref:", actualCurrentQuestion);
  console.log("curr.question_number:", curr.question_number);
  console.log("mockData.timeOut:", mockData.timeOut);
  console.log("questionData.length:", questionData.length);
  console.log("obj1==",obj1);
  
  // Determine complete status
  let complete = 0;
  console.log("Checking complete conditions:");
  console.log("curr.question_number === questionData.length - 1:", curr.question_number === questionData.length - 1);
  console.log("mockData.timeOut:", mockData.timeOut);
  console.log("mockData.timeOutFlag:", mockData.timeOutFlag);
  console.log("mockData.secondCount <= 1:", mockData.secondCount <= 1);
  
  // For timeout scenarios, always set complete = 1
  // If this function is called and it's not the last question, it's likely a timeout
  if (curr.question_number === questionData.length - 1 || mockData.timeOut || mockData.timeOutFlag || mockData.secondCount <= 1) {
    complete = 1;
    console.log("Setting complete = 1 - normal conditions");
  } else {
    // Force complete = 1 for timeout scenarios (when timer expires)
    complete = 1;
    console.log("Setting complete = 1 - forced for timeout");
  }
  
  console.log("Final complete value:", complete);
  
  let bodyFormData = new FormData();
  
  if (routeState.pending == 1) {
    bodyFormData.append('result_id', routeState.id);
  }
  
  bodyFormData.append('q_count', questionData.length);
  bodyFormData.append('mock_id', routeState.id);
  bodyFormData.append('q_time', 0);
  bodyFormData.append('pending', 1);
  bodyFormData.append('curr_q', 0);  // FIX: Use actualCurrentQuestion
  bodyFormData.append('complete', complete);
  
  // FIX: Use curr.question_number directly
  console.log("Sending question_number:", curr.question_number);
  
  bodyFormData.append('question_number', curr.question_number);
  bodyFormData.append('time', mockData.secondCount);
  bodyFormData.append('response[]', obj1.response);
  bodyFormData.append('device', 'website');
  
  // Handle different question types
  if ([1, 2, 3, 4, 5, 21, 22].includes(obj1.type)) {
    bodyFormData.append('answer[]', obj1.q_ans);
    bodyFormData.append('file[]', new Blob(['hello worllllllllllllld']));
  } else if ([6, 7].includes(obj1.type)) {
    bodyFormData.append('answer[]', obj1.q_ans);
    bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
  } else {
    bodyFormData.append('answer[]', obj1.q_ans);
    bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
  }
  
  bodyFormData.append('selected[]', '');
  bodyFormData.append('text[]', obj1.answer);
  bodyFormData.append('type[]', obj1.type);
  bodyFormData.append('id[]', obj1.id);
  bodyFormData.append('duration[]', 0);
  bodyFormData.append('script[]', obj1.script);
  bodyFormData.append('q_ans[]', obj1.q_ans);
  bodyFormData.append('audio_text[]', '');
  bodyFormData.append('html[]', '');
  bodyFormData.append('text_answer[]', '');
  bodyFormData.append('length[]', 0);
  bodyFormData.append('lang[]', '');
  bodyFormData.append('correct[]', '');
  bodyFormData.append('ans[]', obj1.q_ans);
  
  API({
    method: 'POST',
    url: 'submit/mock',
    data: bodyFormData
  }).then(data => {
    console.log("api hit from testbody - complete:", complete);
    
    let filteredAry = mockData.ids.filter(function (e) {
      return e.id !== obj1.id;
    });
    setMockData((prevState) => {
      return {
        ...prevState,
        qTime: 0,
        ids: filteredAry,
      };
    });
    
    // Call submitFailed API
    setTimeout(() => {
      let formData = new FormData();
      if (mockData.failed && mockData.failed.length > 0) {
        mockData.failed.forEach((value, index) => {
          value.forEach((val, key) => {
            if (key === 'file[]') {
              formData.append('files[]', val);
            } else {
              formData.append(`data[${index}][${key}]`, val);
            }
          });
        });
      }
      
      API({
        method: 'POST',
        url: 'submitFailed/mock',
        data: formData
      }).catch(() => {});
    }, 2000);
  }).catch((error) => {
    console.error('Submit failed:', error);
  });
  };
  const showTest = () => {
    setMockData((prevState) => {
      return {
        ...prevState,
        resourceTested: true,
        secondCount: prevState.mockTime,
      };
    });
  };

  const mainData = showMockInfo ? (
    <MockInfo
      setShowMockInfo={setShowMockInfo}
      categoriesData={mockData.categoriesData}
      initialTime={mockData.initialTime}
      category={mockData.mockCat}
    />
  ) : (
    <div className="content questionsArea">
      <Row>
        <Col xs={12}>
          <Card>
            <TestHeader
              mockData={mockData}
              setMockData={setMockData}
              id={routeState.id}
              ref={timerRef}
              finalObjectCreation={questionsFunctions?.finalObjectCreation || fallbackFinalObjectCreation}
              finalSubmit={questionsFunctions?.finalSubmit || fallbackFinalSubmit}
            />
           {
            mockData.dashboardFlag && mockData.complete == 1  ? (
              <>
              <CardBody>
                <Row className="unselectable">
                  <Col>
                    You've finished this test. Click on the button to 
                    <NavLink to={"/admin/results"}>
                     {" "}
                    <Button
                    color="primary" size="xs"
                    // disabled={(this.state.answer_submitted && this.state.failed_submitted) ? false : true}
                     >
                      See Results
                     </Button>{" "}
                    </NavLink>
                   </Col>
               </Row>
             </CardBody>
              </>
            ) : mockData.complete == 0 && mockData.dashboardFlag ? (
              <>
              <Unfinished/>
              </>
            ) : (
              <>
               <Questions
              mockData={mockData}
              setMockData={setMockData}
              routeState={routeState}
              soundArr={soundArr}
              timerRef={timerRef}
              onFunctionsReady={setQuestionsFunctions}
              currentQuestionRef={currentQuestionRef}
            />
              </>
            )
           }
          </Card>
        </Col>
        <BottomBtns mockData={mockData} setMockData={setMockData} />
      </Row>
    </div>
  );

  return (
    <>
      <PopUps mockData={mockData} setMockData={setMockData} />
      {mockData.mockCat && !mockData.resourceTested && (
        <ResourceCheck
          showTest={showTest}
          pending={0}
          data={{}}
          cat={mockData.mockCat}
        />
      )}

      {mockData.resourceTested && mainData}
    </>
  );
};

export default TestBody;
